import {
  fetchLead,
  submitNativeForm,
} from './nativeFormBase';
import extractFormValues from './extractFormValues';
import LoadingStates from './loadingStates';
import { instanceMethods } from '../validate';

export default class NativeFormAPI {
  /*
    options:
      - customFormId - id of the custom form that you will be submitting against
      - host - host of where the request will go
      - form - html form that we will be submitting for
      - redirectUrl - this is wherever you want the form to be redirected to once
        the form submission is successful.
      - submitButtonSelector - selector to find submit buttton
  */
  constructor (options = {}) {
    this.afterSubmit = options.afterSubmit || function afterSubmit () {};
    this.customFormId = options.customFormId;
    this.customFormRedirectPath = options.customFormRedirectPath;
    this.form = options.form;
    this.formSelector = options.formSelector;
    this.host = options.host;
    this.loadingStateText = options.loadingStateText || 'Loading';
    this.submitButtonSelector = options.submitButtonSelector;
    this.submitButton = this.form.querySelector(this.submitButtonSelector);
    this.submitBtnText = options.submitBtnText || this.submitButton.value;
    this.disabledBtnClass = options.disabledBtnClass || 'btn--disabled';
    this.loadingStates = LoadingStates({
      defaultButtonText: this.submitBtnText,
      submitButton: this.submitButton,
    });

    this.init();
  }

  init () {
    this.form.addEventListener('submit', this.formSubmitHandler);
  }

  findInput = (name) => {
    /*
      Phone isn't a real fieldset value that we have. It is to handle the case
      that we have to inputs for the same field called mobile_no and phone
    */
    if (name === 'phone') {
      return document.getElementById('custom_form_entry_mobile_no');
    }

    return document.getElementById(`custom_form_entry_${name}`);
  };

  formSubmitHandler = (event) => {
    event.preventDefault();
    var transformName = (name, id) => {
      var val = id.split('custom_form_entry_')[1];
      var nameSpace = 'custom_form_entry';
      var normalizedVal = val === 'mobile_no' ? 'phone' : val;
      return [nameSpace, normalizedVal];
    };
    var data = extractFormValues({
      formSelector: this.formSelector,
      transformName,
    });

    var formData = {
      custom_form_entry: data.custom_form_entry,
    };

    this.submit({
      formData,
      customFormId: this.customFormId,
      host: this.host,
    });
  }

  submitSuccessHandler = (response) => {
    this.afterSubmit(response);
  }

  submitErrorHandler = (error) => {
    // Update the form with error messages
    this.loadingStates.removeLoading();
    var { response } = error;

    if (response.status === 422) {
      Object.entries(response.data.errors).map((entry) => {
        var input = this.findInput(entry[0]);
        input.classList.add('form__input--dirty');
        var message = entry[1];
        input.setCustomValidity(message);
        /*
          We use this method since it is the same one that we use for client
          side validations to insert the error div
        */
        instanceMethods.findOrCreateErrorNode({
          input,
          errorMessage: message,
          cb: (currentInput) => {
            var { parentNode } = currentInput;
            return parentNode;
          },
        });
        return input;
      });
    } else {
      console.log('unknown error: ', error.response.status); // eslint-disable-line
    }
  }

  /*
    options:
      - customFormId - customFormId of the custom form that you will be submitting against
      - host- the host that you will be submitting to, i.e., localhost:3000, emerituss.staging.org
      - formData - JSON blob of data formatted for the server
  */
  submit (options = {}) {
    this.loadingStates.applyLoading();
    submitNativeForm(options)
      .then(this.submitSuccessHandler)
      .catch(this.submitErrorHandler);
  }

  fetchOptions () {
    return {
      customFormId: this.customFormId,
      host: this.host,
    };
  }

  fetch () {
    return fetchLead(this.fetchOptions());
  }
}
